// src/routes/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useNavigation } from "./utils/navigation";
import { AuthUserContext } from "./context/AuthUserContext";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import SimpleContext from "./context/SimpleContext";

const ProtectedRoute = ({ children }) => {
  const { goToHome } = useNavigation();
  const { showLoginPopup } = useContext(SimpleContext);
  const { authTokens } = useContext(AuthUserContext);

  if (!authTokens) {
    showLoginPopup();
    return <Navigate to={goToHome()} replace />;
  }
  return children;
};

const ProtectedRouteVerification = ({ children }) => {
  const { authTokens } = useContext(AuthUserContext);
  const { setShowVerification } = useContext(SimpleContext);

  // const decoded = jwtDecode(authTokens.access);
  // console.log("email", decoded.email, decoded.is_email_verified);
  // if (!decoded.is_email_verified) {
  //   setShowVerification(true);
  // }

  return children;
};

const ProtectedRouteSignUpIn = ({ children }) => {
  const { goToAccount } = useNavigation();
  const { authTokens } = useContext(AuthUserContext);

  if (authTokens) {
    return <Navigate to={goToAccount()} replace />;
  }
  return children;
};

export default ProtectedRoute; // Podrazumevani eksport

export { ProtectedRouteSignUpIn, ProtectedRouteVerification }; // Imenovani eksport
